import {Redirect} from "react-router-dom";
import React from "react";
import {clearAll, readFromStorage} from "../api/storageApi";
import { isExpired , decodeToken} from "react-jwt";
import {connect} from "react-redux";
import {logOutMe} from "../redux/authReducer";
import ShowNotification from "../components/common/Notification/ShowNotification";


export const WithAuthRedirect = (Component) => {


    const RedirectComponent = (props) => {
        const token = readFromStorage('accessToken')
        const isAuth = readFromStorage('isAuth')
        if(token != null && isAuth===false){
            // const isMyTokenExpired = isExpired(token);
            // const decodedToken = decodeToken(token);

            // let dateNow = new Date();
            // if (decodedToken === null || decodedToken.exp*1000 < dateNow.getTime()) {
                // ShowNotification("Succes","Building updated successful", "warning")
                clearAll()
                logOutMe()
                window.location.reload();
                // return <Redirect to='/'/>

            // }
        }
        connect({},{logOutMe})(RedirectComponent)


        return <Component {...props}/>
    }


    return RedirectComponent;
}
